import React from 'react';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import {
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag,
  getLuxeFlags
} from '../../../Flags/selectors';
import { getIsPriceRevealPDP, getShowPriceRevealOnSimilar } from '../../../utils/pdp';
import { addCustomerType } from '../../../utils/products';
import { redirect } from '../../../refresh/utils/cartUtils';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import luxeList from '../../../refresh/constants/luxeScreenType';
import {
  luxeGtmProductClick,
  gtmListingProductImpressions,
  getStoreName,
  gtmProductClick,
  gtmPromotionCmsClick,
  gtmPromotionCmsImpressions
} from '../../../modules/ga/GTMdatalayer';
import { getPriceRevealSaleDuration } from '../../common/PriceRevealPLPBanner/priceRevealUtil';
import PriceRevealPLP from '../../common/ListingPage/priceRevealPLP/PriceRevealPLP';
import { getDiscountValue } from '../../../utils/price';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import { getStoresForHidingMRP } from '../../../refresh/selectors/featureFlagsSelector';
import { catalogIdToStoreName } from '../../../utils';
import { checkProductId, setProductId } from '../../../utils/productWidget';

import { readCookie } from '../../common/Cookie';
import properties from '../../../modules/ajio-util/properties';
import { setLandingPageScrollCookies } from '../../../utils/banner';
import {
  handleProductImpressionsForDynamicWidget,
  handleWindowUnloadForDynamicWidgetProductImpressions
} from '../../../fleek/utils/feedGaUtils';
import { checkCategoryImpressionPromoId, emptyBundleCategoryImpressionArray, getBundleCategoryImpressionArray, setBundleCategoryImpressionArray, setCategoryImpressionPromoId } from '../../../utils/NavigationRevamp';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

let storeType = getStoreName() || 'ajio';
const imageBaseUrl = properties.getProperty('imageBaseUrl');
const productWidgetDataListLocalVariable = 'productWidgetDataListWeb';
const dynamicWidgetProductImpressionsIdWeb = 'dynamicWidgetProductImpressionsIdWeb';
const dynamicWidgetProductImpressionsDataWeb = 'dynamicWidgetProductImpressionsDataWeb';
const curatedWidgetBundleData = `curatedWidgetBundleDataWeb${storeType}`;
const curatedWidgetImpressionsData = `curatedWidgetImpressionsDataWeb${storeType}`;

class ProductWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialIndex: 4,
      previousIndex: 0,
      hasObserverBlockCall: false
    };
  }

  componentDidMount() {
    const { curatedWidgetData, rowNumber } = this.props;
    const { curatedWidgetItemList = [], widgetName = '' } = curatedWidgetData;

    curatedWidgetItemList?.forEach((item, index) => {
      const { header } = item;
      let productId = document.getElementById(`${rowNumber}|${index}`);

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.handleGaEventsforCuratedWidgets(
              {
                id: 'MOBILE',
                name: `curated_${header}`,
                creative: `curated_${widgetName}`,
                position: `${rowNumber}|${index}`
              },
              storeType,
              'home landing screen',
              'home screen'
            );
          }
        },
        {
          threshold: 0.5
        }
      );
      if (productId) observer.observe(productId);
    });

    window.addEventListener('beforeunload', this.handleWindowUnload);
  }

  componentWillUnmount() {
    // Clean up the observer when the component unmounts
    window.removeEventListener('beforeunload', this.handleWindowUnload);
  }

  handleWindowUnload = () => {
    let { promotionArray = [], promotionData = {} } =
      getBundleCategoryImpressionArray(curatedWidgetBundleData, true) || {};
    if (promotionArray?.length > 0) {
      const { storeType, pageName, pageType } = promotionData;
      gtmPromotionCmsImpressions(promotionArray, storeType, '', pageType);
      localStorage.removeItem(curatedWidgetBundleData);
    }
  };

  handleGaEventsforCuratedWidgets = (category, storeType, pageName, pageType) => {
    let promotionArray = getBundleCategoryImpressionArray(curatedWidgetBundleData); // Get the bundled data
    let isPromoIdExists = checkCategoryImpressionPromoId(
      category?.position,
      curatedWidgetImpressionsData
    ); // check if data has already made any impressions or not
    if (!isPromoIdExists) {
      promotionArray.push(category);
      setBundleCategoryImpressionArray(curatedWidgetBundleData, promotionArray, {
        storeType,
        pageName,
        pageType
      }); // Add data to the bundle
    }
    if (promotionArray.length === 5) {
      // Fire the impression when bundle lenght reaches 5 and empty the bundle array
      gtmPromotionCmsImpressions(promotionArray, storeType, '', pageType);
      emptyBundleCategoryImpressionArray(curatedWidgetBundleData);
    }
    // Add data to impressions array
    setCategoryImpressionPromoId(category?.position, curatedWidgetImpressionsData);
  };

  //   handleUnloadEvent = () => {
  //     const { newDesignLuxe } = this.props;

  //     handleWindowUnloadForDynamicWidgetProductImpressions(
  //       dynamicWidgetProductImpressionsDataWeb,
  //       !!newDesignLuxe
  //     );
  //   };

  //   handleObserver = () => {
  //     const { productWidgetData = [] } = this.props;
  //     if (productWidgetData && productWidgetData.length)
  //       this.productImpressionsEventPush(productWidgetData.slice(0, 4));
  //   };

  //   productImpressionsEventPush = product => {
  //     const { newDesignLuxe, heading, rowNumber, componentName, bannerType, banners } = this.props;
  //     const isDynamicProductWidget = bannerType === 'DYNAMIC_WIDGET' || false;
  //     let { landing: { screenType = '', screenName = '' } = {} } = luxeScreen;
  //     const storeType = getStoreName();
  //     let impressions = [];
  //     product?.map((data, index) => {
  //       const {
  //         name: description,
  //         brand,
  //         code = '',
  //         price: { value: priceValue = '' },
  //         fnlColorVariantData: {
  //           colorGroup: productColor = '',
  //           exclusiveTill: isExclusive = '',
  //           productTag = ''
  //         } = {},
  //         brickCategory: productCategory = '',
  //         brickName,
  //         discount = '',
  //         catalogName = '',
  //         segmentId = '',
  //         experimentId = ''
  //       } = data;

  //       const productId = code && code.length > 9 ? code.substring(0, 9) : code;
  //       const tag = isExclusive ? 'Exclusive' : productTag;
  //       let listValue = `${screenName} - ${heading}`;
  //       const dimension60Data =
  //         Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
  //       if (isDynamicProductWidget) {
  //         listValue =
  //           banners.widgetLevel.toLowerCase() === 'user'
  //             ? `user_level_${banners?.feedLogic}_${heading}_${rowNumber}`
  //             : `dynamic_${banners?.feedLogic}_${heading}_${rowNumber}`;
  //       }

  //       let impressionData = {
  //         name: description,
  //         id: productId,
  //         price: priceValue,
  //         brand,
  //         category: productCategory,
  //         list: listValue,
  //         position: index,
  //         dimension6: description,
  //         dimension7: productId, // pass value for product_id
  //         dimension8: brand, // pass value for product_brand
  //         dimension9: priceValue, // pass value for product_price
  //         dimension10: productColor, // pass value for product_color
  //         dimension11: productCategory, // pass value for product_category
  //         dimension12: brickName, // pass value for product_brick
  //         dimension13: tag, // pass value for product_tag
  //         dimension14: '', // pass value for product_size
  //         dimension15: discount, // pass value for product_trade_discount
  //         dimension16: storeType, // pass value for Store_type,
  //         dimension23: catalogIdToStoreName(catalogName),
  //         dimension60: dimension60Data,
  //         dimension170: getDiscountValue(discount)
  //       };
  //       const isProductIdExists = checkProductId(productId, productWidgetDataListLocalVariable);
  //       if (!isProductIdExists) {
  //         impressions.push(impressionData);
  //         setProductId(productId, productWidgetDataListLocalVariable);
  //       }
  //     });
  //     if (impressions.length > 0) {
  //       if (isDynamicProductWidget) {
  //         impressions.forEach(imprsn => {
  //           handleProductImpressionsForDynamicWidget(
  //             dynamicWidgetProductImpressionsDataWeb,
  //             dynamicWidgetProductImpressionsIdWeb,
  //             imprsn,
  //             storeType,
  //             screenName,
  //             screenType,
  //             '',
  //             !!newDesignLuxe
  //           );
  //         });
  //       } else {
  //         gtmListingProductImpressions({
  //           impressions,
  //           list: 'landing screen',
  //           store_type: storeType,
  //           page_name: screenName,
  //           page_type: screenType,
  //           contains_luxe: !!newDesignLuxe
  //         });
  //       }
  //     }
  //   };

  onNextClick = index => {
    const { curatedWidgetData, rowNumber } = this.props;
    const { curatedWidgetItemList = [], widgetName = '' } = curatedWidgetData;
    let productId = document.getElementById(`${rowNumber}|${index}`);
    let slidesToShow = parseInt(productId.dataset.slidetoshow)
    let header = productId.dataset.header
    let newIndex = index + slidesToShow - 1
    let observerdProductId = document.getElementById(`${rowNumber}|${newIndex}`);

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.handleGaEventsforCuratedWidgets(
            {
              id: 'MOBILE',
              name: `curated_${header}`,
              creative: `curated_${widgetName}`,
              position: `${rowNumber}|${newIndex}`
            },
            storeType,
            'home landing screen',
            'home screen'
          );
        }
      },
      {
        threshold: 0.5
      }
    );
    if (observerdProductId) observer.observe(observerdProductId);
  };

  render() {
    const {
      metaData = {},
      priceRevealMetaInfoProductWidget,
      productWidgetData,
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData = {},
      store,
      priceRevealLUXEFlag,
      newDesignLuxe,
      eventPush,
      currentStore,
      flags,
      storesForHidingMRP,
      bannerType,
      ctaSettings,
      viewShowMoreProducts,
      dynamicProductWidgetRedirection,
      heading,
      rowNumber,
      banners,
      curatedWidgetData
    } = this.props;
    const priceRevealMetaInfo = priceRevealMetaInfoProductWidget;
    const isPriceReveal = getPriceRevealSaleDuration(
      flags,
      'desktop',
      priceRevealMetaInfo,
      newDesignLuxe ? 'luxe' : 'ajio'
    );
    const { curatedWidgetItemList = [], widgetName = '' } = curatedWidgetData;
    return (
      <div className="comp-section product-widget">
        <DataList
          storesForHidingMRP={storesForHidingMRP}
          data={productWidgetData}
          metaData={metaData}
          isPriceReveal={isPriceReveal}
          eventPush={eventPush}
          newDesignLuxe={newDesignLuxe}
          currentStore={currentStore}
          onNextClick={this.onNextClick}
          priceRevealMetaInfo={priceRevealMetaInfo}
          bannerType={bannerType}
          ctaSettings={ctaSettings}
          viewShowMoreProducts={viewShowMoreProducts}
          dynamicProductWidgetRedirection={dynamicProductWidgetRedirection}
          heading={heading}
          rowNumber={rowNumber}
          banners={banners}
          curatedWidgetData={curatedWidgetData}
        />
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick, isDynamicProductWidget = false } = props;
  let showNextArrow = true;
  if (isDynamicProductWidget && className.includes('slick-disabled')) showNextArrow = false;
  return showNextArrow && <div className={className} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
}

class DataList extends React.Component {
  render() {
    const { landing: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const {
      landingList: { widgetList = '' }
    } = luxeList;
    const {
      isPriceReveal,
      newDesignLuxe,
      eventPush,
      currentStore,
      onNextClick,
      priceRevealMetaInfo,
      storesForHidingMRP,
      bannerType,
      ctaSettings,
      viewShowMoreProducts,
      dynamicProductWidgetRedirection,
      heading,
      rowNumber,
      banners,
      curatedWidgetData,
      isLoading
    } = this.props;
    const isDynamicProductWidget = true;
    const { enable: isCTAEnabled = false, ctaText = '' } = ctaSettings;
    const {feedLogic='',widgetLevel='', showDefault = true} = banners;
    const slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      lazyLoad: true,
      lazyLoadOffset: 1,
      nextArrow: <SampleNextArrow isDynamicProductWidget={true} />,
      prevArrow: <SamplePrevArrow />,
      afterChange: onNextClick,
      className: 'arrow-styles'
    };
    const { curatedWidgetItemList = [], widgetName = '' } = curatedWidgetData;
    const dataListItems = curatedWidgetItemList.map((data, index) => {
      const {
        images: { product: image = '' },
        filters = '',
        header = '',
        subheader = ''
      } = data;

      return (
        <div key={index} id={`${rowNumber}|${index}`} data-header={header} data-slidetoshow={slickSettings.slidesToShow} className={'product-div-margin-auto'}>
          <a
            href="#"
            className="product-widget-card"
            target="_self"
            rel=""
            onClick={e => {
              e.preventDefault();
              window.location.href = `/d2c-fashion/c/83?isCuratedWidget=true&WidgetName=${widgetName}&subHeading=${subheader}&widgetItemFilters=${filters}&widgetLevel=${widgetLevel}&feedLogic=${feedLogic}&heading=${header}&${widgetLevel?.toLowerCase() === 'user' ? 'showDefaultIfNoData='+showDefault : ''}`;
              gtmPromotionCmsClick(
                'MOBILE',
                `curated_${header}`,
                `curated_${widgetName}`,
                `${rowNumber}|${index}`,
                getStoreName(),
                'home landing screen',
                'home screen'
              );
            }}
          >
            <div
              className={`sec-prod-disp ${newDesignLuxe ? 'prod-widget-desc-disp' : ''}`}
              style={{
                width: newDesignLuxe ? '230px' : '204px',
                height: newDesignLuxe ? '288px' : '256px'
              }}
            >
              <img
                className="product-widget-img"
                src={replaceWithJioCDN(`${image}`)}
                alt={data.description || 'product image'}
                width={newDesignLuxe ? '230px' : '204px'}
                height={newDesignLuxe ? '288px' : '256px'}
              />
            </div>

            <div
              className="sec-product-details"
              style={{ width: newDesignLuxe ? '230px' : '204px', marginTop:'11px' }}
            >
              <div className="sec-prod-title" aria-label={header}>
                {header}
              </div>

              <div className="sec-prod-subtitle prod-widget-desc" aria-label={subheader}>
                {subheader}
              </div>
            </div>
          </a>
        </div>
      );
    });

    if (curatedWidgetItemList.length > 4) {
      return (
        <div className={'product-widget-slider dynamic-product-widget-slider'}>
          <Slider {...slickSettings} ref="slick">
            {dataListItems}
          </Slider>
        </div>
      );
    } else {
      return (
        <div className={'product-widget-slider dynamic-product-widget-slider'}>
          <Row className="center">{dataListItems}</Row>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {}, metaData = {} } = state;
  const { sis, name } = metaData;
  const storeName = getCurrentStore(state);
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    productWidgetData: ownProps.products,
    metaData: state.metaData,
    flags: state.flags,
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    store: sis ? name : 'AJIO',
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    currentStore: storeName,
    newDesignLuxe,
    storesForHidingMRP: getStoresForHidingMRP(state)
  };
};

export default ProductWidget = connect(mapStateToProps)(ProductWidget);
